export enum INCIDENT_NOTES_SORT_ORDER {
    NONE = 'All',
    NEW_NOTES = 'New notes first',
    OLD_NOTES = 'Old notes first',
    STATUS = 'Status change',
    SEVERITY = 'Severity change',
    ASSIGNMENT_CHANGE = 'Assignment change',
}
